import { useEffect } from 'react';

// Sekme başlığını (ve opsiyonel meta description) sayfaya göre ayarlar (SEO).
export const usePageTitle = (title?: string, description?: string) => {
  useEffect(() => {
    const base = 'Kapsül Teknoloji Platformu';
    document.title = title ? `${title} · ${base}` : base;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
};
